import Svg from 'app/features/component/svg'
import {
	HStack,
	Text,
	VStack,
	useBreakpointValue,
	Pressable,
	FlatList,
	Box,
} from 'native-base'
import { useRef, useState } from 'react'
import { TouchableOpacity, useWindowDimensions } from 'react-native'

type ScreenStaticCarouselProps = {
	currentIndex: number
	onPressLeft: () => void
	onPressRight: () => void
}
const screenTitleList = [
	'성적 예측',
	'대학 예측',
	'공부 능력치 평가',
	'성향 분석',
	'나에게 맞는 사교육 방법은?',
	'지금 내가 다니는 학원',
	'나는 어디까지 학습이 가능할까?',
	'나에게 딱맞는 과목별 공부법',
	'목표 대학 공부 SPEC',
	'전체 공부 시간 늘리기',
	'과목별 학습 시간 제안',
	'세부 학습시간 계획표',
]
const screenImageList = [
	{
		asset: require('app/assets/main/img_mockup_01.png'),
		src: '/main/img_mockup_01.png',
	},
	{
		asset: require('app/assets/main/img_mockup_02.png'),
		src: '/main/img_mockup_02.png',
	},
	{
		asset: require('app/assets/main/img_mockup_03.png'),
		src: '/main/img_mockup_03.png',
	},
	{
		asset: require('app/assets/main/img_mockup_04.png'),
		src: '/main/img_mockup_04.png',
	},
	{
		asset: require('app/assets/main/img_mockup_05.png'),
		src: '/main/img_mockup_05.png',
	},
	{
		asset: require('app/assets/main/img_mockup_06.png'),
		src: '/main/img_mockup_06.png',
	},
	{
		asset: require('app/assets/main/img_mockup_07.png'),
		src: '/main/img_mockup_07.png',
	},
	{
		asset: require('app/assets/main/img_mockup_08.png'),
		src: '/main/img_mockup_08.png',
	},
	{
		asset: require('app/assets/main/img_mockup_09.png'),
		src: '/main/img_mockup_09.png',
	},
	{
		asset: require('app/assets/main/img_mockup_10.png'),
		src: '/main/img_mockup_10.png',
	},
	{
		asset: require('app/assets/main/img_mockup_11.png'),
		src: '/main/img_mockup_11.png',
	},
	{
		asset: require('app/assets/main/img_mockup_12.png'),
		src: '/main/img_mockup_12.png',
	},
]

const ScreenStaticCarousel = ({
	currentIndex,
	onPressLeft,
	onPressRight,
}: ScreenStaticCarouselProps) => {
	const iconSize = useBreakpointValue({
		lg: '88px',
		base: '80px',
	})
	const screenShotSize = useBreakpointValue({
		lg: {
			width: '577px',
			height: '900px',
		},
		base: {
			width: '375px',
			height: '585px',
		},
	})
	const { width } = useWindowDimensions()

	const maxWidth = width > 1280 ? '696px' : '480px'

	return (
		<HStack
			maxWidth={maxWidth}
			position="relative"
			alignItems="center"
			justifyContent="center"
		>
			<Svg
				width={screenShotSize.width}
				height={screenShotSize.height}
				asset={screenImageList[currentIndex]?.asset}
				src={screenImageList[currentIndex]?.src}
			/>
			<HStack
				left={0}
				width="100%"
				position="absolute"
				justifyContent="space-between"
			>
				<TouchableOpacity
					onPress={() => {
						if (currentIndex !== 0) {
							onPressLeft()
						}
					}}
				>
					<Svg
						width={iconSize}
						height={iconSize}
						src="/main/arrow_left_mo.png"
						asset={require('app/assets/main/arrow_left_mo.png')}
					/>
				</TouchableOpacity>
				<TouchableOpacity
					onPress={() => {
						if (currentIndex !== screenImageList.length - 1) {
							onPressRight()
						}
					}}
				>
					<Svg
						width={iconSize}
						height={iconSize}
						src="/main/arrow_right_mo.png"
						asset={require('app/assets/main/arrow_right_mo.png')}
					/>
				</TouchableOpacity>
			</HStack>
		</HStack>
	)
}

export default function DiagnosticScreen () {
	const DiagnosticScreenSectionLg = () => {
		const [selectedScreenIndex, setSelectedScreenIndex] = useState(0)
		return (
			<HStack
				w="100%"
				maxWidth="1280px"
				justifyContent="center"
				py="50px"
			>
				{/* 왼쪽 안내 텍스트 렌더링 부분 */}
				<VStack space="32px" maxWidth="433px">
					{screenTitleList.map((title, index) => (
						<HStack key={title} space="16px">
							{selectedScreenIndex === index
								? (
									<Svg
										width="45px"
										height="45px"
										src="/main/checkbox_round.svg"
										asset={require('app/assets/main/checkbox_round.svg')}
									/>
								)
								: (
									<Box width="45px" height="45px" />
								)}
							<Pressable
								height="45px"
								onPress={() => {
									setSelectedScreenIndex(index)
								}}
							>
								<Text
									size={
										selectedScreenIndex === index
											? 'h4/800'
											: 'h4/600'
									}
									color={
										selectedScreenIndex === index
											? 'primary.400'
											: 'gray.400'
									}
								>
									{title}
								</Text>
							</Pressable>
						</HStack>
					))}
				</VStack>
				<Box w="100%" maxWidth="167px" flexShrink={1} />
				{/* 오른쪽 스크린샷 슬라이더 렌더링 부분  */}
				<ScreenStaticCarousel
					currentIndex={selectedScreenIndex}
					onPressLeft={() => {
						setSelectedScreenIndex((v) => {
							return v - 1
						})
					}}
					onPressRight={() => {
						setSelectedScreenIndex((v) => {
							return v + 1
						})
					}}
				/>
			</HStack>
		)
	}

	const DiagnosticScreenSectionBase = () => {
		const [selectedScreenIndex, setSelectedScreenIndex] = useState(0)
		const flatListRef = useRef(null)
		const onPressLeft = () => {
			const nextIndex = selectedScreenIndex - 1
			// @ts-ignore
			flatListRef.current?.scrollToIndex({
				index: nextIndex,
				viewPosition: 0.5,
			})
			setSelectedScreenIndex(nextIndex)
		}
		const onPressRight = () => {
			const nextIndex = selectedScreenIndex + 1
			// @ts-ignore
			flatListRef.current?.scrollToIndex({
				index: nextIndex,
				viewPosition: 0.5,
			})
			setSelectedScreenIndex(nextIndex)
		}
		const onPressTitle = (index: number) => {
			// @ts-ignore
			flatListRef.current?.scrollToIndex({
				index,
				viewPosition: 0.5,
			})
			setSelectedScreenIndex(index)
		}

		return (
			<VStack alignItems="center">
				<HStack
					zIndex={10}
					width="100%"
					position="absolute"
					pointerEvents="none"
					justifyContent="space-between"
				>
					<Box
						width={'70px'}
						height={'50px'}
						zIndex={10}
						display={selectedScreenIndex === 0 ? 'none' : 'flex'}
						bgColor={{
							linearGradient: {
								colors: ['#FFFFFFFF', '#FFFFFF00'],
								start: [0, 1],
								end: [1, 1],
							},
						}}
					/>
					<Box
						width={'70px'}
						height={'50px'}
						zIndex={10}
						display={
							selectedScreenIndex === screenImageList.length - 1
								? 'none'
								: 'flex'
						}
						bgColor={{
							linearGradient: {
								colors: ['#FFFFFF00', '#FFFFFFFF'],
								start: [0, 1],
								end: [1, 1],
							},
						}}
					/>
				</HStack>
				<FlatList
					px="24px"
					width="375px"
					horizontal
					ref={flatListRef}
					showsHorizontalScrollIndicator={false}
					ItemSeparatorComponent={() => <Box width="20px" />}
					data={screenTitleList}
					renderItem={({ item, index }) => (
						<Pressable
							onPress={() => {
								onPressTitle(index)
							}}
						>
							<Text
								size={
									selectedScreenIndex === index
										? 'h6/800'
										: 'h6/600'
								}
								color={
									selectedScreenIndex === index
										? 'primary.400'
										: 'gray.300'
								}
							>
								{item}
							</Text>
						</Pressable>
					)}
				/>
				<ScreenStaticCarousel
					currentIndex={selectedScreenIndex}
					onPressLeft={onPressLeft}
					onPressRight={onPressRight}
				/>
			</VStack>
		)
	}

	// 모바일과 데스크탑의 UI 동작 방식이 달라져서 분리 시킴
	return useBreakpointValue({
		lg: DiagnosticScreenSectionLg(),
		base: DiagnosticScreenSectionBase(),
	})
}
